
























import {
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import { debounce } from '~/utils/function'
import { DEBOUNCE_DEFAULT } from '~/constants/debounce'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  props: formFieldProps,
  components: { FieldError, CTextArea },
  setup(props, { emit }) {
    const { specs, name } = toRefs(props)
    const { value, error, debouncedValueChanged } = useClassifiedForm(props)
    const formValidationBuilder = useDep(FormValidationBuilder)

    const textAreaRef = ref<HTMLElement | null>(null)

    const placeholder = computed(() => specs.value.placeholder)

    const handleTextAreaInput = (text: string) => {
      // this can probably be removed, since the text area's max length is determined by the maxlength attribute
      formValidationBuilder
        .new(error)
        .maxChars(specs.value.max, text)
        .validate()
      debouncedValueChanged(name.value, text)
    }

    onMounted(() => {
      // TODO: this applies to dispatched only fields, since they require a resize update to update the iframe height
      //  remove in the future
      if (textAreaRef.value && 'ResizeObserver' in window) {
        new ResizeObserver(
          debounce(() => {
            emit('update')
          }, DEBOUNCE_DEFAULT) as any
        ).observe(textAreaRef.value.$el)
      }
    })

    return {
      placeholder,
      value,
      error,
      handleTextAreaInput,
      textAreaRef
    }
  }
})
